import { BigNumberish, ethers } from 'ethers';

export default function formatEther(
  value: BigNumberish,
  maxDecimalDigits: number = 18
) {
  return ethers.FixedNumber.from(ethers.utils.formatEther(value))
    .round(maxDecimalDigits)
    .toString();
}
